import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import Perfil from '../components/Perfil'; // Asegúrate que esté en minúscula si así lo nombraste

const PerfilPage: React.FC = () => {
  return (
    <>
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Banner />
      <div style={{ flex: 1 }}>
      <Perfil />
      </div>
      <Footer />
      </div>
    </>
  );
};

export default PerfilPage;
